import React from 'react'

const Success = () => {
  return (
    <div>

    <style>{`
      .center-div {
        text-align: center;
        padding: 40px 0;
        background: #EBF0F5;
      }
        h1 {
          color: #88B04B;
      
          font-weight: 900;
          font-size: 40px;
          margin-bottom: 10px;
        }
        p {
          color: #404F5E;
         
          font-size:20px;
          margin: 0;
        }
      .i {
        color: #9ABC66;
        font-size: 100px;
        line-height: 200px;
        margin-left:-15px;
      }
      .card {
        background: white;
        padding: 60px;
        border-radius: 4px;
        box-shadow: 0 2px 3px #C8D0D8;
        display: inline-block;
        margin: 0 auto;
        max-width: 700px !important;
      }

      .Icon-border{
      border-radius: 200px;
  height: 200px;
  width: 200px;
  background: rgb(248, 250, 245);
  margin: 0px auto;
      }

      @media screen and (max-width: 746px) {
       .card {
        background: white;
        padding: 30px 10px;
        border-radius: 4px;
        box-shadow: 0 2px 3px #C8D0D8;
        display: inline-block;
        margin: 0 auto;
      }
         .i {
        color: #9ABC66;
        font-size: 50px;
        line-height: 98px;
        margin-top: 0px;
      }

      h1 {
  color: #88B04B;
 
  font-weight: 900;
  font-size: 28px;
  margin-bottom: 10px;
  margin-top: 20px;
}

       .Icon-border{
      border-radius: 100px;
  height: 100px;
  width: 100px;
  background: rgb(248, 250, 245);
  margin: 0px auto;
      }
      }
    `}
    </style>

    <div className='center-div'>
    <div className=" card" style={{marginTop: '100px', maxWidth: '500px'}}>
  <div className='Icon-border' >
    <i className="checkmark i">✓</i>
  </div>
  <h1>Thank You!</h1> 
  <p className='mt-3'>Thank you for becoming a member of <strong>MSB Association</strong>. Your payment has been received and your membership details have been submitted successfully. We truly value your commitment and are thrilled to welcome you.</p> <p className='mt-3'>One of our team members will be in touch shortly via email with next steps and membership information.</p> <p className='mt-3'>If you have any questions in the meantime, please feel free to reach out to us. <br /> <hr /><strong>Thank you once again for joining us!</strong></p>
</div>
    </div>


    </div>
  )
}

export default Success
